import type { Meta, StoryFn } from '@storybook/react';

import { ThemeOverride, Rating } from '@pega/cosmos-react-core';
import type { RatingProps } from '@pega/cosmos-react-core';

export default {
  title: 'Core/Rating',
  component: Rating,
  excludeStories: ['ConfigurableRating']
} as Meta;

interface RatingStoryProps extends RatingProps {
  ariaLabel?: string;
}

export const RatingDemo: StoryFn<RatingStoryProps> = (args: RatingStoryProps) => {
  return (
    <Rating
      maxRating={args.maxRating}
      value={args.value}
      metaInfo={args.metaInfo}
      aria-label={args.ariaLabel}
    />
  );
};

RatingDemo.args = {
  maxRating: 5,
  value: 3.6,
  metaInfo: '52 reviews',
  ariaLabel: '3.6 out of 5 stars based on 52 reviews'
};

RatingDemo.argTypes = {
  maxRating: { control: { type: 'number' } },
  value: { control: { type: 'number' } },
  metaInfo: { control: { type: 'text' } },
  ariaLabel: { control: { type: 'text' } }
};

interface ConfigurableRatingProps {
  color?: string;
}

export const ConfigurableRating: StoryFn<ConfigurableRatingProps> = (
  args: ConfigurableRatingProps
) => {
  return (
    <ThemeOverride
      theme={{
        components: {
          rating: {
            color: args.color
          }
        }
      }}
    >
      <Rating
        maxRating={5}
        value={3.6}
        metaInfo='52 reviews'
        aria-label='3.6 out of 5 stars based on 52 reviews'
      />
    </ThemeOverride>
  );
};

ConfigurableRating.args = {
  color: '#939393'
};

ConfigurableRating.argTypes = {
  color: { control: { type: 'color' } }
};
